import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import SingleAction from './SingleAction';


const RowActionComponent = props => {
  const { actions }= props;
  const [renderOptions, setRenderOptions] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const ref: React.RefObject<HTMLDivElement>= useRef(null);

  const handleAwayClick = (event: any) => {
    if (!ref?.current?.contains(event.target)) {
      setRenderOptions(false);
    }
  };
  
  useEffect(() => {
    document.addEventListener('click', (e) => handleAwayClick(e));
    return document.removeEventListener('click', (e) => handleAwayClick(e));
  }, [ref]);
  
  const handleClick = async (onClick: Function) => {
    if (!disabled) {
      setDisabled(true);
      try {
        await onClick();
        setDisabled(false);
        setRenderOptions(false);
      } catch (e) {
        setDisabled(false);
      }
    }
  };
  
  return (
    <div ref={ref} className={styles['main-container']}>
      <i
        className={`fa fa-ellipsis-v ${styles['option-icon']}`}
        onClick={() => setRenderOptions(!renderOptions)}
      />
      {renderOptions && (
        <div
          id={'menu-items-container'}
          className={styles['menu-items-container']}
        >
          {actions.map((action, i) => (
            <SingleAction
              key={i}
              action={action}
              disabled={disabled}
              onClick={() => handleClick(action.onClick)}
            />
          ))}
          <div className={styles['row-pointer']}>
            <i className={'fa fa-caret-right'} />
          </div>
        </div>
      )}
    </div>
  );
};

export default RowActionComponent;